import { Injectable } from '@angular/core';
import * as braintree  from 'braintree-web';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpResponse, HttpHeaders, HttpEventType } from '@angular/common/http';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class BraintreeService {

  constructor(private http: HttpClient) { }


  submitPaymentMethod(card_model: any): Promise<any> {
  	return new Promise((resolve, reject) => {

  		this.getSdkKey().then(sdk_key => {

  		braintree.client.create({
		  authorization: sdk_key
		}, function (createErr, clientInstance) {
		  let data:any = {
		    creditCard: {
		      cardholderName: card_model.cardholder_name,
		      number: card_model.card_number,
		      cvv: card_model.cvv,
		      expirationDate: card_model.month + '/' + card_model.year,
		      billingAddress: {
		        postalCode: card_model.postal_code,
		        countryCodeAlpha2: card_model.country,
		      },
		      options: {
		        validate: false
		      }
		    }
		  };

		  // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
		  // payment fields cannot be hosted on your checkout page.
		  // For an alternative to the following, use Hosted Fields.
		  clientInstance.request({
		    endpoint: 'payment_methods/credit_cards',
		    method: 'post',
		    data: data
		  }, function (requestErr, response) {
		    // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
		    if (requestErr) {
		    	reject(requestErr);
		    }

		    resolve(response);

		  });



  	});

},
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });

  });

 }

 getDeviceData(): Promise<string> {

 	return new Promise((resolve, reject) => {

 		this.getSdkKey().then(sdk_key => {
 			let dataCollector = braintree.dataCollector.create({
			  authorization: sdk_key
			}, function (create_error, clientInstance) {
				if(create_error){
					reject(create_error);
				}

				clientInstance.getDeviceData().then(function (deviceData) {
				  resolve(deviceData);
				});

			});

 		}).catch(error => {
 			reject(error);
 		});




 	});

 }

 private getSdkKey(): Promise<string> {
    return new Promise((resolve, reject) => {
       return this.http.get(AppSettings.API_ENDPOINT + 'payments/get_braintree_sdk_key').subscribe((response:any) => {

        resolve(response);

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

   getPaymentMethodNonce(device_data: string, cardholder_name: string, cc_number: string, cvv: string, exp_month: string, exp_year: string, postal_code: string, country_code: string): Promise<any> {
 	 	return new Promise((resolve, reject) => {

 		this.getSdkKey().then(sdk_key => {
 			let client = braintree.client.create({
			  authorization: sdk_key
			}, function (create_error, clientInstance) {
				if(create_error){
					reject(create_error);
				}

				clientInstance.request({
					endpoint: 'payment_methods/credit_cards',
    				method: 'post',
    				data: {
    					creditCard: {
    					deviceData: device_data,
    					cardholderName: cardholder_name,
      					number: cc_number,
      					cvv: cvv,
      					expirationMonth: exp_month,
      					expirationYear: exp_year,
      					billingAddress: {
        					postalCode: postal_code,
        					countryCodeAlpha2: country_code
      					},
					      options: {
					        validate: false
					      }
    				}
    			   }
				}).then(function (response) {

					console.log(response);

					if(response._httpStatus != 200){
						reject(response);
					}

				  	resolve(response.creditCards[0]);

				});

			});

 		}).catch(error => {
 			reject(error);
 		});




 	});
 }

}
